import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import FileUpload from "./upload";
import { useLocation } from "react-router-dom";

const FileUploadWrapper = () => {
  const location = useLocation();
  const [path, setPath] = useState("");
  useEffect(() => {
    setPath(location.pathname?.replaceAll("/file/", ""));
  }, []);
  return (
    <>
      {path === "lse" && (
        <FileUpload
          fileType={path}
          fileUploadTypeName={"lse"}
          filePath={"lsesampledata"}
          title={"LSE Outage"}
        />
      )}
      {path === "lseprestorm" && (
        <FileUpload
          fileType={path}
          fileUploadTypeName={"lsePreStorm"}
          filePath={"lseprestormsampledata"}
          title={"LSE Pre-Storm"}
        />
      )}
    </>
  );
};
const mapStateToProps = (state: any) => ({
  user: state.user,
  cpp: state.cpp,
  configs: state.config.list,
});

export default connect(mapStateToProps)(FileUploadWrapper);
